import { Box, Card, CardContent, CardMedia, Typography } from '@mui/material';
import { Video } from '../types';

export const VideoCard = ({
  video,
  onClick,
  selected,
  isNew,
}: {
  video: Video;
  onClick: (videoId: string) => void;
  selected: boolean;
  isNew: boolean;
}) => {
  const duration = video.duration_seconds ? video.duration_seconds : 0;
  const durationLabel =
    duration > 3600
      ? `${Math.floor(duration / 3600)}:${
          Math.floor((duration % 3600) / 60) < 10 ? '0' + Math.floor((duration % 3600) / 60) : Math.floor((duration % 3600) / 60)
        }:${duration % 60 < 10 ? '0' + (duration % 60) : duration % 60}`
      : `${Math.floor(duration / 60)}:${duration % 60 < 10 ? '0' + (duration % 60) : duration % 60}`;
  return (
    <Card
      onClick={() => onClick(video.id)}
      sx={{
        height: '220px',
        width: '100%',
        maxHeight: '220px',
        cursor: 'pointer',
        border: selected ? '2px solid #007bff' : 'none',
        backgroundColor: isNew ? 'action.hover' : 'inherit',
        transition: 'background-color 0.5s ease',
      }}
      title={video.title + ' - ' + new Date(video.published_at).toLocaleDateString()}
    >
      <CardMedia component="img" image={video.thumbnail} alt={video.title} />
      <Box sx={{ backgroundColor: 'rgba(0, 0, 0, 0.5)', padding: 0.5, borderRadius: 1, float: 'right' }}>
        <Typography variant="caption" color="white">
          {durationLabel}
        </Typography>
      </Box>
      <CardContent sx={{ padding: 1 }}>
        <Typography
          variant="h6"
          sx={{
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            display: '-webkit-box',
            WebkitLineClamp: 2,
            WebkitBoxOrient: 'vertical',
            lineHeight: '1.2em',
            maxHeight: '2.4em',
          }}
        >
          {video.title}
        </Typography>
        <Typography
          variant="caption"
          color="text.secondary"
          sx={{
            display: 'block',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
          }}
        >
          {new Date(video.published_at).toLocaleDateString()}
        </Typography>
      </CardContent>
    </Card>
  );
};
